import cn from 'classnames';
import {twMerge} from 'tailwind-merge';

export const twx = (...props) => twMerge(cn(props));
